import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import Headers from "../header";
import Footer from "../footer/footer";
import { useNavigate } from "react-router-dom";

const Intro = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("login") === "true";

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/search-bar");
    }
  }, [isLoggedIn]);

  const containerVariants = {
    hidden: { opacity: 0, y: 500 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeInOut" },
    },
  };

  return (
    <>
      <Headers />
      <motion.section
        className="section-wrap intro angle-bottom"
        id="intro"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Container>
          <div className="text-center">
            <h2 className="intro-heading heading-frame">Welcome</h2>
            <p className="intro-text mb-60">
              Discover the power of DogmatixAI, your go-to AI-powered company
              research tool! With lightning-fast precision, unearth the most
              pertinent information about any company in mere seconds. Whether
              you're delving into financial insights, market trends, or key
              players, DogmatixAI streamlines your research process, ensuring
              you stay ahead of the curve effortlessly. Experience the future of
              company analysis today!
            </p>
          </div>
        </Container>
      </motion.section>
      <Footer />
    </>
  );
};

export default Intro;
